import script from "./ValidatorSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorSessionDetailsPage.vue?vue&type=style&index=0&id=b4717cb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4717cb8"]])

export default __exports__